import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { HttpContext, HttpCustomError, HttpResultProvider } from 'app/core/providers';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private httpResultProvider: HttpResultProvider) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError((error: any) => {
                    const context: HttpContext = {
                        error: error?.error,
                        serviceUrl: error.url,
                        statusCode: error.status
                    };

                    const httpCustomError: HttpCustomError = this.httpResultProvider.getCustomErrorFromContext(context);

                    return throwError(httpCustomError);
                })
            );
    }
}
